import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  saveBookingBullionRequest,
  saveBookingBullionSuccess,
  saveBookingBullionFailure,
  getBookingBullionRequest,
  getBookingBullionSuccess,
  getBookingBullionFailure,
  getBookingStatusHistoryRequest,
  getBookingStatusHistorySuccess,
  getBookingStatusHistoryFailure,
  updateBookingStatusRequest,
  updateBookingStatusSuccess,
  updateBookingStatusFailure,
  revokeBookingRequest,
  revokeBookingSuccess,
  revokeBookingFailure,
  getTransactionRequest,
  getTransactionSuccess,
  getTransactionFailure,
  getBookingReportRequest,
  getBookingReportSuccess,
  getBookingReportFailure,
  getTransactionSummaryRequest,
  getTransactionSummarySuccess,
  getTransactionSummaryFailure,
} from "./bookingBullionSlice";

const getBookingBullionApi = async ({ page, limit, search }) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/getBookingBullion?page=${page}&limit=${limit}&search=${search || ""}`,
  );
  return response.data;
};

function* handleGetBookingBullion(action) {
  try {
    const response = yield call(getBookingBullionApi, action.payload);

    if (response?.success) {
      yield put(getBookingBullionSuccess(response.data));
    } else {
      yield put(getBookingBullionFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch booking bullion";

    yield put(getBookingBullionFailure(message));
    yield call(toast.error, message);
  }
}
const saveBookingBullionApi = async (payload) => {
  const formData = new FormData();

  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/saveBookingBullion`,
    formData,
  );

  return response.data;
};

function* handleSaveBookingBullion(action) {
  try {
    const response = yield call(saveBookingBullionApi, action.payload);

    if (response?.success) {
      yield put(saveBookingBullionSuccess(response));

      yield call(
        toast.success,
        response.message || "Booking saved successfully",
      );

      yield put(
        getBookingBullionRequest({
          page: 1,
          limit: 10,
        }),
      );
    } else {
      yield put(saveBookingBullionFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to save booking bullion";

    yield put(saveBookingBullionFailure(message));
    yield call(toast.error, message);
  }
}

const getBookingStatusHistoryApi = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/bookingBullionStatus/${id}`,
  );
  return response.data;
};

function* handleGetBookingStatusHistory(action) {
  try {
    const response = yield call(getBookingStatusHistoryApi, action.payload);

    if (response?.success) {
      const sorted = [...response.data].sort(
        (a, b) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
      );
      yield put(getBookingStatusHistorySuccess(sorted));
    } else {
      yield put(getBookingStatusHistoryFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch status history";

    yield put(getBookingStatusHistoryFailure(message));
    yield call(toast.error, message);
  }
}

const updateBookingStatusApi = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/updateBookingBullionStatus`,
    payload,
  );
  return response.data;
};
function* handleUpdateBookingStatus(action) {
  try {
    const response = yield call(updateBookingStatusApi, action.payload);

    if (response?.success) {
      yield put(updateBookingStatusSuccess(response));

      yield call(
        toast.success,
        response.message || "Status updated successfully",
      );

      yield put(
        getBookingBullionRequest({
          page: 1,
          limit: 10,
        }),
      );
      if (action.payload?.id) {
        yield put(getBookingStatusHistoryRequest(action.payload.id));
      }
    } else {
      yield put(updateBookingStatusFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to update status";

    yield put(updateBookingStatusFailure(message));
    yield call(toast.error, message);
  }
}

const revokeBookingApi = async (bookingId) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/revokeBookingBullion`,
    { bookingId },
  );
  return response.data;
};
function* handleRevokeBooking(action) {
  try {
    const response = yield call(revokeBookingApi, action.payload);

    if (response?.success) {
      yield put(revokeBookingSuccess(response));

      yield call(
        toast.success,
        response.message || "Booking revoked successfully",
      );

      yield put(
        getBookingBullionRequest({
          page: 1,
          limit: 10,
        }),
      );
      if (action.payload) {
        yield put(getBookingStatusHistoryRequest(action.payload));
      }
    } else {
      yield put(revokeBookingFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to revoke booking";

    yield put(revokeBookingFailure(message));
    yield call(toast.error, message);
  }
}

const getTransactionReportApi = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/getAllTransaction`,
    payload,
  );

  return response.data;
};

function* handleGetTransactionReport(action) {
  try {
    const response = yield call(getTransactionReportApi, action.payload);

    if (response?.success) {
      yield put(getTransactionSuccess(response.data));
    } else {
      yield put(getTransactionFailure(response.message));

      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch transaction report";

    yield put(getTransactionFailure(message));

    yield call(toast.error, message);
  }
}

const getBookingReportApi = async ({ page, limit, search }) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/getBookingReport?page=${page}&limit=${limit}&search=${search || ""}`,
  );

  return response.data;
};

function* handleGetBookingReport(action) {
  try {
    const response = yield call(getBookingReportApi, action.payload);

    if (response?.success) {
      yield put(getBookingReportSuccess(response));
    } else {
      yield put(getBookingReportFailure(response.message));

      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch booking report";

    yield put(getBookingReportFailure(message));

    yield call(toast.error, message);
  }
}

const getTransactionSummaryApi = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking-bullion/getTransactionByDate`,
    payload,
  );

  return response.data;
};
function* handleGetTransactionSummary(action) {
  try {
    const response = yield call(getTransactionSummaryApi, action.payload);

    if (response?.success) {
      yield put(getTransactionSummarySuccess(response.data));
    } else {
      yield put(getTransactionSummaryFailure(response.message));

      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch transaction summary";

    yield put(getTransactionSummaryFailure(message));

    yield call(toast.error, message);
  }
}

export default function* bookingBullionSaga() {
  yield takeLatest(getBookingBullionRequest.type, handleGetBookingBullion);
  yield takeLatest(saveBookingBullionRequest.type, handleSaveBookingBullion);
  yield takeLatest(
    getBookingStatusHistoryRequest.type,
    handleGetBookingStatusHistory,
  );
  yield takeLatest(updateBookingStatusRequest.type, handleUpdateBookingStatus);
  yield takeLatest(revokeBookingRequest.type, handleRevokeBooking);
  yield takeLatest(getTransactionRequest.type, handleGetTransactionReport);
  yield takeLatest(getBookingReportRequest.type, handleGetBookingReport);
  yield takeLatest(
    getTransactionSummaryRequest.type,
    handleGetTransactionSummary,
  );
}
